import { render, staticRenderFns } from "./PageBlacklist.vue?vue&type=template&id=2f967ba9&"
import script from "./PageBlacklist.vue?vue&type=script&lang=ts&"
export * from "./PageBlacklist.vue?vue&type=script&lang=ts&"
import style0 from "./PageBlacklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports